import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NgxStripeModule } from 'ngx-stripe';

const components: any = [];

@NgModule({
  imports: [SharedModule],
  exports: [SharedModule, NgxStripeModule, components],
  declarations: [components]
})
export class SignUpSharedModule {}
